import env from "../utils/env";
import { prepareHyHttpHeaders } from "../utils/http";
import { extractSearchData } from "../utils/extract-search-data";

export function getSnapshotData(insObj) {
  const configObj = {
    healthInsurancePayerId: insObj.hyPayerId,
    healthInsuranceMemberId: insObj.member_id,
    dob: insObj.dob,
    firstName: insObj.firstName,
    lastName: insObj.lastName,
    member_id: insObj.member_id,
    version: 2,
    isCheckInsurance: true
  };
  const config = `${insObj.hyPayerId}?${extractSearchData(configObj)}`;

  return fetch(`${env("BASE_HY_URL")}insurance/eligibility/${config}`, {
    headers: prepareHyHttpHeaders()
  })
    .then(res => {
      return res.json();
    })
    .catch(() => {});
}
